module.exports = __webpack_public_path__ + "img/youchuo-yibaoming.ff3a6146.png";